module.exports = __webpack_public_path__ + "img/1.db6b8b57.png";